<script>

import {vMaska} from "maska/vue"


export default {
  name: "RegUser",
  directives: {maska: vMaska},
  data() {
    return {
      userPhotoRef: require("@/assets/user.png"),
      user: {
        firstname: '',
        lastname: '',
        dni: '',
        dniScan: null,
        bd: '',
        address: '',
        personalPhoneNumber: '',
        gender: '',
        bloodType: '',
        allergies: '',
        civilStatus: '',
        children: 0,
        rtn: '',
        academicFormation: '',
        emergencyContactName: '',
        emergencyContactNumber: '',
        bankAccount: '',
        bankName: '',
        hiringDate: '',
        userPhoto: require("@/assets/user.png"),

      },
      userAuth: {
        email: '',
        personalEmail: '',
      },
      agreement: {
        agreementType: 'Acuerdo',
        code: '',
        doc: null,
        fooDate: '',
        effectiveDate: '',
      },
      jobTitle: '',
      jobTitleID: 0,
      possibleJobTitles: '',
      fileButton1: 'Subir archivo',
      fileButton2: 'Subir archivo',
      dniFileName: '',
      agreementFileName: ''

    }
  },

  methods: {
    triggerFileUpload(refName) {
      this.$refs[refName].click();
    },
    handleFileUpload1() {
      const maxFileSize = 1024 * 1024;
      const file = this.$refs.dniFile.files[0];

      if (file.size > maxFileSize) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El tamaño del archivo supera el límite de 1MB',
          customClass: {
            popup: 'mySwal'
          }
        });
        this.$refs.dniFile.value = '';
        return;
      }

      this.user.dniScan = file
      this.dniFileName = this.user.dniScan.name;
      this.fileButton1 = this.dniFileName ? `Archivo: ${this.dniFileName}` : `Subir archivo`
      console.log("Nombre de archivo " + this.dniFileName)
    },
    handleFileUpload2() {
      const maxFileSize = 2 * 1024 * 1024;
      const file = this.$refs.agreementFile.files[0];

      if (file.size > maxFileSize) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El tamaño del archivo supera el límite de 2MB',
          customClass: {
            popup: 'mySwal'
          }
        });
        this.$refs.agreementFile.value = '';
        return;
      }

      this.agreement.doc = file;
      this.agreementFileName = this.agreement.doc.name;
      this.fileButton2 = this.agreementFileName ? `Archivo: ${this.agreementFileName}` : `Subir archivo`
      console.log("Nombre de archivo " + this.agreementFileName)
    },
    validatePersonalEmail() {
      this.userAuth.personalEmail = this.userAuth.personalEmail.replace(/[^\w.@-]| /g, '')
      this.userAuth.personalEmail = this.userAuth.personalEmail.toLowerCase()
      const atSymbolIndex = this.userAuth.personalEmail.indexOf('@')
      if (atSymbolIndex !== -1) {
        this.userAuth.personalEmail = this.userAuth.personalEmail.slice(0, atSymbolIndex + 1) + this.userAuth.personalEmail.slice(atSymbolIndex + 1).replace(/@/g, '')
      }
      while (this.userAuth.personalEmail.includes('..')) {
        this.userAuth.personalEmail = this.userAuth.personalEmail.replace('..', '.')
      }
    },
    validateInstitutionalEmail() {
      this.userAuth.email = this.userAuth.email.replace(/[^\w.@-]| /g, '')
      this.userAuth.email = this.userAuth.email.toLowerCase()
      const atSymbolIndex = this.userAuth.email.indexOf('@')
      if (atSymbolIndex !== -1) {
        this.userAuth.email = this.userAuth.email.slice(0, atSymbolIndex + 1) + this.userAuth.email.slice(atSymbolIndex + 1).replace(/@/g, '')
      }
      while (this.userAuth.email.includes('..')) {
        this.userAuth.email = this.userAuth.email.replace('..', '.')
      }
    },
    getJobTitleID() {
      let selectedItem = this.possibleJobTitles.find(jobTitle => (jobTitle.code + " " + jobTitle.title) === this.jobTitle);
      if (selectedItem !== undefined) {
        this.jobTitleID = selectedItem.id;
      } else {
        this.jobTitleID = 0;
      }
    },
    beforeRegUser() {
      if (this.user.firstname.length === 0) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El nombre es obligatorio',
          customClass: {
            popup: 'mySwal'
          }
        })
        return true
      }
      if(this.user.lastname.length === 0){
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'El apellido es obligatorio',
            customClass: {
              popup: 'mySwal'
            }
          })
          return true
      }
      if(this.user.dni.length === 0){
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'El DNI es obligatorio',
            customClass: {
              popup: 'mySwal'
            }
          })
          return true
      }
      if(this.user.bd.length === 0){
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'La fecha de nacimiento es obligatoria',
            customClass: {
              popup: 'mySwal'
            }
          })
          return true
      }
      if(this.user.gender.length === 0){
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'El genero es obligatorio',
            customClass: {
              popup: 'mySwal'
            }
          })
          return true
      }
      if(this.agreement.agreementType.length === 0){
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El tipo de contratacion es obligatorio',
          customClass: {
            popup: 'mySwal'
          }
        })
        return true
      }
      if(this.agreement.code.length === 0){
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El codigo de contratacion es obligatorio',
        })
        return true
      }
      if (this.user.hiringDate === 0) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'La fecha de contratacion es obligatoria',
          customClass: {
            popup: 'mySwal'
          }
        })
        return true
      }
      if (this.jobTitleID === 0) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'El puesto de trabajo es obligatorio',
          customClass: {
            popup: 'mySwal'
          }
        })
        return true
      }

      return false;

    },
    async regUser() {
      if (this.beforeRegUser()){
        return;
      }

      try {

        let formData = new FormData();

        let userCopy = {...this.user};

        userCopy.userPhoto = null;

        userCopy.bd = userCopy.bd.length > 0 ? userCopy.bd + "T01:01:01-06:00" : "0000-01-01T01:01:01-06:00"
        userCopy.hiringDate = userCopy.hiringDate.length > 0 ? userCopy.hiringDate + "T01:01:01-06:00" : "0001-01-01T01:01:01-06:00"

        userCopy.gender = userCopy.gender === "Masculino" ? "M" : userCopy.gender === "Femenino" ? "F" : "na";

        //delete userCopy.dniScan;
        let userJson = JSON.stringify(userCopy);
        formData.append('user', userJson);
        //formData.append('dniScan', this.user.dniScan)
        formData.append('jobTitle', this.jobTitleID)

        let userAuthCopy = {...this.userAuth};
        let userAuthJson = JSON.stringify(userAuthCopy);
        formData.append('userAuth', userAuthJson);

        let agreementCopy = {...this.agreement};

        agreementCopy.fooDate = agreementCopy.fooDate.length > 0 ? agreementCopy.fooDate + "T01:01:01-06:00" : "0002-01-01T01:01:01-06:00"
        agreementCopy.effectiveDate = agreementCopy.effectiveDate.length > 0 ? agreementCopy.effectiveDate + "T01:01:01-06:00" : "0002-01-01T01:01:01-06:00"
        //delete agreementCopy.doc;
        let agreementJson = JSON.stringify(agreementCopy);
        formData.append('agreement', agreementJson);
        //formData.append('doc', this.agreement.doc);

        let result = await this.$api.post("/auth/users", formData);
        console.log("Data : " + this.user.dniScan)
        console.log("Type : " + typeof this.user.dniScan)
        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }

        console.log(result.status.toString())
      } catch (error) {
        console.log(error)
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar el usuario',
          customClass: {
            popup: 'mySwal'
          }
        });
      }
    },
    async getJoTAll() {
      let result = await this.$api.get("/auth/job_availables")
      if (result.status.toString() === "200") {
        this.possibleJobTitles = result.data
      }
    },
    editPhoto() {
    }
  },
  created() {
    this.getJoTAll()
  }
}
</script>

<template>

  <div id="section-0" class="container">


    <div class="form-reg-user">
      <h1>Registrar Usuario</h1>
      <form class="Form">

        <!--<div class="usrPhoto" onclick="editPhoto()">
          <img class="usrPhotoDetail" :src="user.userPhoto">
        </div>-->

        <div class="grid-container">
          <div>
            <label>Nombre</label>
            <input type="text" v-model="user.firstname" placeholder="Nombres" maxlength="70">
          </div>

          <div>
            <label>Apellido</label>
            <input type="text" v-model="user.lastname" placeholder="Apellidos" maxlength="70">
          </div>
        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>DNI</label>
            <input type="text" v-model="user.dni" v-maska :data-maska="'####-####-#####'"
                   placeholder="0000-0000-00000">
          </div>

          <div>
            <label>RTN</label>
            <input type="text" v-model="user.rtn" v-maska data-maska="##############"
                   placeholder="00000000000000">
          </div>

         <!-- <div>
            <label>DNI - Escaneado</label>

            <button
                id="upload1"
                @click.prevent="triggerFileUpload('dniFile')"
            > {{ fileButton1 }}
            </button>
            <input
                type="file"
                id="dniFile"
                ref="dniFile"
                v-show="false"
                @change="handleFileUpload1">
          </div> -->

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Fecha de nacimiento</label>
            <input type="date" v-model="user.bd">
          </div>

          <div>
            <label>Domicilio</label>
            <textarea v-model="user.address"
                      placeholder="Direccion" maxlength="600"></textarea>
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Correo personal</label>
            <input type="email" v-model="userAuth.personalEmail"
                   placeholder="ejemplo.correo@mail.com" v-on:input="validatePersonalEmail">
          </div>

          <div>
            <label>Correo institucional</label>
            <input type="email" v-model="userAuth.email"
                   placeholder="ejemplo.correo@sde.gob.hn" v-on:input="validateInstitutionalEmail">
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Telefono Personal</label>
            <input type="text" v-model="user.personalPhoneNumber" v-maska data-maska="####-####"
                   placeholder="0000-0000">
          </div>

          <div>
            <label>Genero: {{ user.gender }}</label>

            <div>
              <select v-model="user.gender">
                <option disabled value="">Seleccione una opcion</option>
                <option>Masculino</option>
                <option>Femenino</option>
                <option>Otro</option>
              </select>
            </div>
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Tipo de sangre: {{ user.bloodType }}</label>

            <div>
              <select v-model="user.bloodType">
                <option disabled value="">Seleccione una opcion</option>
                <option>A+</option>
                <option>A-</option>
                <option>B+</option>
                <option>B-</option>
                <option>AB+</option>
                <option>AB-</option>
                <option>O+</option>
                <option>O-</option>
              </select>
            </div>
          </div>

          <div>
            <label>Alergias</label>
            <textarea v-model="user.allergies"
                      placeholder="Alergias" maxlength="600"></textarea>
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Estado civil: {{ user.civilStatus }}</label>

            <div>
              <select v-model="user.civilStatus">
                <option disabled value="">Seleccione una opcion</option>
                <option>Casado</option>
                <option>Soltero</option>
                <option>Union libre</option>
                <option>Viudo</option>
              </select>
            </div>
          </div>

          <div>
            <label>Hijos</label>
            <input type="number" v-model="user.children"
                   placeholder=00>
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">


          <div>
            <label>Formación académica</label>
            <textarea v-model="user.academicFormation"
                      placeholder="Formación académica" maxlength="600"></textarea>
          </div>

        </div>


        <label id="centeredLabel">Contacto de emergencia</label>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Nombre</label>
            <input type="text" v-model="user.emergencyContactName" placeholder="Nombre" maxlength="70">

          </div>

          <div>
            <label>Telefono</label>
            <input type="text" v-model="user.emergencyContactNumber" v-maska data-maska="####-####"
                   placeholder="0000-0000">

          </div>
        </div>

        <label id="centeredLabel">Informacion bancaria</label>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Banco</label>
            <input type="text" v-model="user.bankName" placeholder="Banco" maxlength="70">

          </div>

          <div>
            <label>Numero de cuenta</label>
            <input type="text" v-model="user.bankAccount" v-maska data-maska="##############################"
                   placeholder="000000000000000000000000000000">
          </div>
        </div>

        <label id="centeredLabel">Informacion de contratacion</label>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Modalidad: {{ agreement.agreementType }}</label>

            <div>
              <select v-model="agreement.agreementType">
                <option disabled value="">Seleccione una opcion</option>
                <option>Acuerdo</option>
                <option>Contrato</option>
                <option>Reintegro</option>
              </select>
            </div>
          </div>

          <div>
            <label>Fecha de contratación</label>
            <input type="date" v-model="user.hiringDate">
          </div>

        </div>

        <div id="checkboxS" class="checkbox-container">
          <div>
            <label>Codigo de {{ agreement.agreementType }}</label>
            <input type="text" v-model="agreement.code"
                   placeholder="Codigo" maxlength="70">
          </div>

          <div>
            <label>Puesto de trabajo</label>
            <input list="posDep" v-model="jobTitle" @input="getJobTitleID" placeholder="Seleccione una opcion">
            <datalist id="posDep">
              <option v-for="jobTitle in possibleJobTitles" :key="jobTitle.id"
                      :value="`${jobTitle.code} ${jobTitle.title}`"></option>
            </datalist>
          </div>
        </div>

        <div id="checkboxS" class="checkbox-container">
          <!-- <div>
            <label>{{ agreement.agreementType }} - Escaneado</label>
            <button
                id="upload2"
                @click.prevent="triggerFileUpload('agreementFile')"
            > {{ fileButton2 }}
            </button>
            <input
                type="file"
                id="agreementFile"
                ref="agreementFile"
                v-show="false"
                @change="handleFileUpload2"
                accept="application/pdf">

          </div> -->

          <div>
            <div v-if="!(agreement.agreementType === 'Acuerdo')">
              <label v-if="agreement.agreementType === 'Reintegro'">Fecha de reintegro</label>
              <label v-if="!(agreement.agreementType === 'Reintegro')">Culminacion del contrato</label>
              <input type="date" v-model="agreement.fooDate">
            </div>
          </div>
        </div>

        <button type="submit" @click.prevent="regUser">Registrar</button>
      </form>
    </div>

  </div>
</template>


<style>


.Form label {
  width: 300px;
  text-align: left;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}

.checkbox {
  appearance: none;
  display: none;
  height: 0;
  width: 0;

  & + label {
    display: inline-block;
    margin-bottom: .5em;
    padding: .75em 1.25em;
    border-radius: 100em;
    color: var(--gobGray);
    background-color: #ffffff;
  }

  &:checked + label {
    background-color: var(--gobBlue);
    color: white;
  }
}


.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* this splits your container into two equal width columns */
  grid-gap: 1em; /* this is optional, it sets some space between your columns */
  width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.checkbox-container {
  grid-template-columns: 1fr 1fr;
  display: grid;
  justify-content: space-between;
  gap: 20px;
  width: 800px;
  margin: auto;
}

#centeredLabel {
  display: block;
  text-align: center;
}

.usrPhoto {
  margin: auto;
  display: flex;
  width: 200px;
  height: 200px;
  background-color: var(--gobBlue);
  justify-content: center;
  align-items: center;
  border-radius: 15px;
}

.usrPhotoDetail {
  width: 160px;
  height: 160px;
}

</style>
